import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import * as Sentry from '@sentry/browser';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(err, info) {
    this.setState({ hasError: true });
    Sentry.withScope((scope) => {
      scope.setExtras(info);
      Sentry.captureException(err);
    });
  }

  render() {
    const { hasError } = this.state;
    const { t } = this.props;
    if (hasError) {
      return <h1>{t('Something went wrong.')}</h1>;
    }
    const { children } = this.props;
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ErrorBoundary);
